const validate = values => {
	const errors = {};
	if (!values.plate) {
	  errors.plate = 'El campo es obligatorio';
	} else if (!/^[a-zA-Z0-9]{6,7}$/.test(values.plate)) {
	  errors.plate = 'El formato no es válido';
	}
	return errors;
  }
  export default validate;


/** WEBPACK FOOTER **
 ** ./src/components/Validations/syncValidationsCarAsPaymentPlateForm.js
 **/